/**
 * pf
 */
export default
    {
        path: "/bs",
        component: () => import('@/views/MainContent/MainContent'),
        children: [
            {
                path: 'member-center/homepage',
                name: 'homepage',
                component: () => import('@/views/bs/member-center/HomePage'),
                meta: {
                    keepAlive: true,
                    title: '个人首页'
                }
            },
            {
                path: 'task/list',
                name: 'TaskTags',
                component: () => import('@/views/pf/task/TaskTags'),
                meta: {
                    keepAlive: false,
                    title: '任务管理'
                }
            },
            {
                path: 'task/add',
                name: 'addTask',
                component: () => import('@/views/bs/task/add'),
                meta: {
                    keepAlive: true,
                    title: '发布任务'
                }
            },
            {
                path: 'task/edit',
                name: 'editTask',
                component: () => import('@/views/bs/task/edit'),
                meta: {
                    keepAlive: false,
                    title: '编辑任务'
                }
            },
            {
                path: 'task/fee-standard',
                name: 'feeStandard',
                component: () => import('@/views/bs/task/Fee-standard'),
                meta: {
                    keepAlive: true,
                    title: '收费付费标准'
                }
            },
            {
                path: 'acct/bill-flow',
                name: 'billFlow',
                component: () => import('@/views/pf/acct/bill-flow'),
                meta: {
                    keepAlive: false,
                    title: '收支明细'
                }
            },
            {
                path: 'acct/charge-list',
                name: 'chargeList',
                component: () => import('@/views/pf/acct/charge-list'),
                meta: {
                    keepAlive: false,
                    title: '充值列表'
                }
            },
            {
                path: 'acct/add-charge',
                name: 'add-charge',
                component: () => import('@/views/bs/add-charge'),
                meta: {
                    keepAlive: false,
                    title: '账户充值'
                }
            },
            {
                path: 'acct/charge-result',
                name: 'charge-result',
                component: () => import('@/views/bs/charge-result'),
                meta: {
                    keepAlive: false,
                    title: '充值成功'
                }
            },
            {
                path: 'task/complaint',
                name: 'TaskTags',
                component: () => import('@/views/pf/task/ComplaintTags'),
                meta: {
                    keepAlive: true,
                    title: '投诉列表'
                }
            },{
                path: 'member-center/noticeList',
                name: 'noticeList',
                component: () => import('@/views/bs/member-center/noticeList'),
                meta: {
                    keepAlive: false,
                    title: '全部公告'
                }
            },
            {
                path: 'shop/list',
                name: 'ShopList',
                component: () => import('@/views/bs/shop/List'),
                meta: {
                    keepAlive: true,
                    title: '绑定店铺'
                }
            },
            {
                path: 'user/info',
                name: 'userInfo',
                component: () => import('@/views/bs/user/Info'),
                meta: {
                    keepAlive: true,
                    title: '基本资料'
                }
            },
            {
                path: 'business/subAccount',
                name: 'subAccount',
                component: () => import('@/views/bs/business/subAccount'),
                meta: {
                    keepAlive: false,
                    title: '商家子账号'
                }
            },
            {
              path: 'task/template',
              name: 'templateList',
              component: () => import('@/views/bs/template/List'),
              meta: {
                keepAlive: true,
                title: '任务模板'
              }
            }
        ]

    }



// WEBPACK FOOTER //
// ./src/router/bs.js